// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__T+PWG","background":"Profile_background__KuOCr","profile_text":"Profile_profile_text__nMSgy","dropdown_content":"Profile_dropdown_content__p-puf"};